import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"

const endpoints = {
  image: (imageId: string) => getUrlForEnv(services.IMAGES_SERVICE, `/v1/images/${imageId}`),
  images: () => getUrlForEnv(services.IMAGES_SERVICE, "/v1/images")
}

export default endpoints
